export default "__VITE_ASSET__CY0yW9BM__"